export const DAY_OF_WEEK_FORMAT = 'ddd';
export const DATE_FORMAT = 'MMM DD, YYYY';
